import React from 'react';

export const SvgTouchApp = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.551 6v3.74c-1.21-.81-2-2.18-2-3.74 0-2.49 2.01-4.5 4.5-4.5s4.5 2.01 4.5 4.5c0 1.56-.79 2.93-2 3.74V6a2.5 2.5 0 00-5 0zm4.61 6c.31 0 .61.07.89.21l4.08 2.03c.77.38 1.21 1.22 1.09 2.07l-.63 4.47c-.14.99-.98 1.72-1.98 1.72h-6.1c-.53 0-1.04-.21-1.42-.58l-4.01-4.01c-.43-.44-.43-1.14 0-1.58.27-.27.66-.39 1.03-.31l3.44.72V6c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.61z"
      fill="currentColor"
    />
  </svg>
);
